export const TRANSACTION_BUFFER_PERCENTAGE = 0.001;
